import { isVariantPayloadKey } from './mdx-manifest';
import type { Manifest, QueryLike } from './mdx-manifest';
import {
  buildPublishingContext,
  resolveManifestEntry,
} from './mdx-manifest-resolver';
import {
  loadManifest as defaultLoadManifest,
  loadMdxPayloadFromDisk as defaultLoadMdxPayloadFromDisk,
} from './mdx-payload';
import type { MdxPayload } from './mdx-payload';

interface ResolveMdxVariantPayloadRequestOptions {
  query: QueryLike;
  allowQueryOverrides: boolean;
  loadManifest?: () => Promise<Manifest>;
  loadMdxPayloadFromDisk?: (payloadKey: string) => Promise<MdxPayload | null>;
}

function firstQueryValue(value: string | string[] | undefined): string | null {
  if (Array.isArray(value)) {
    return value[0] || null;
  }
  return value || null;
}

async function resolveMdxVariantPayloadRequest({
  query,
  allowQueryOverrides,
  loadManifest = defaultLoadManifest,
  loadMdxPayloadFromDisk = defaultLoadMdxPayloadFromDisk,
}: ResolveMdxVariantPayloadRequestOptions): Promise<MdxPayload | null> {
  const slug = firstQueryValue(query.publicSlug) || firstQueryValue(query.slug);
  const payloadKey = firstQueryValue(query.payloadKey);
  if (!slug || !payloadKey || !isVariantPayloadKey(payloadKey)) {
    return null;
  }

  const manifest = await loadManifest();
  const publishingContext = buildPublishingContext({
    manifest,
    query,
    allowQueryOverrides,
  });
  const resolved = resolveManifestEntry(manifest, slug, publishingContext);

  if (resolved?.source !== 'mdx' || resolved.payloadKey !== payloadKey) {
    return null;
  }

  return loadMdxPayloadFromDisk(payloadKey);
}

export { resolveMdxVariantPayloadRequest };
export type { ResolveMdxVariantPayloadRequestOptions };
